module.exports = __webpack_public_path__ + "img/48000.ebb34b06.jpg";